import { render, staticRenderFns } from "./MyPaymentsTableWeb.vue?vue&type=template&id=4b66fe16&scoped=true"
import script from "./MyPaymentsTableWeb.vue?vue&type=script&lang=js"
export * from "./MyPaymentsTableWeb.vue?vue&type=script&lang=js"
import style0 from "./MyPaymentsTableWeb.vue?vue&type=style&index=0&id=4b66fe16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66fe16",
  null
  
)

export default component.exports